import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import PersonalInfo from "@/pages/medewerkers/$userId/persoonlijke_gegevens/PersonalInfo"
import { can } from "@/utils/can"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/persoonlijke_gegevens/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data } = useCurrentUserSuspenseQuery()

  return (
    <PersonalInfo
      userId={data?.data.userId}
      canEdit
      canEditRole={can("update", "employees")}
    />
  )
}
